let lastAction = null;

export default {
  set: (time)=>{
    lastAction = time;
  },
  get: ()=>lastAction
}